import { OnInit } from '@angular/core';
import { OnDestroy } from '@angular/core';
import { Output } from '@angular/core';
import { Inject } from '@angular/core';
import { Component } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EventEmitter } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'app-login-timeout',
  templateUrl: './login-timeout.component.html',
  styleUrls: ['./login-timeout.component.scss']
})
export class LoginTimeoutComponent implements OnInit, OnDestroy{

  @Output() active = new EventEmitter();

  public seconds = 60;
  private timer: any;

  constructor(public snackBar: MatSnackBar,
              @Inject(MAT_SNACK_BAR_DATA) public snackBarType: string) {}

  ngOnInit(): void {

    if (this.snackBarType === 'timeout'){
      this.countdown();
    }
  }

  ngOnDestroy(): void {
    this.seconds = 60;
  }

  private countdown(): void {

    this.timer = window.setInterval(() => {
      this.seconds = this.seconds - 1;

      if (this.seconds === 0) {
        window.clearInterval(this.timer);
        this.snackBar._openedSnackBarRef.dismiss(); // auto dismiss incase window is not in focus
      }
    }, 1000);
  }

  public onDismiss(): void {
    this.snackBar
        ._openedSnackBarRef
        ?.dismissWithAction();
  }

  public onContinue(): void {
    clearInterval(this.timer);
    this.seconds = 60;
    this.snackBar
        ._openedSnackBarRef
        ?.dismissWithAction();
    this.active
        .emit();
  }
}
